// extracted by mini-css-extract-plugin
export var additionalTitle = "header-module--additional-title--KoRQh";
export var childrenContainer = "header-module--children-container--kOewm";
export var heroImage = "header-module--hero-image--H8Uwp";
export var heroImageSmall = "header-module--hero-image-small--DFxFX";
export var leftSide = "header-module--left-side--T1DyP";
export var logoContainerHeader = "header-module--logo-container-header--Mvx-w";
export var outerWrapper = "header-module--outer-wrapper--ygma+";
export var rightSide = "header-module--right-side--JM1Gm";
export var titleLime = "header-module--title-lime--1njD0";